/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useDevice } from '@squiz/dxp-console-support';
import React from 'react';
import { Divider, DividerTextAlignment } from '../../../Divider';
import { SdsTextSize } from '../../../SdsText';
import { SideNavItem } from '../SideNavItem';
import { SideNavSectionProps } from './SideNavSection.props';

/**
 * Main navigation menu section.
 */
export const SideNavSection = (props: SideNavSectionProps): JSX.Element => {
  const { menuSection } = props;
  const { dataId, label: sectionLabel } = menuSection;

  // Device detection
  const deviceType = useDevice();

  const getMenuItems = (): Array<JSX.Element> => {
    return menuSection.items.map((item): JSX.Element => {
      // Don't display the item if it's not meant for this device
      if (item.devices && !item.devices.includes(deviceType)) {
        return <React.Fragment key={item.key}></React.Fragment>;
      }

      return (
        <React.Fragment key={item.key}>
          <SideNavItem menuItem={item} />
        </React.Fragment>
      );
    });
  };

  return (
    <section data-id={dataId}>
      {menuSection.showLabel && (
        <div className="sds-sidenav-section">
          <Divider text={sectionLabel} textAlignment={DividerTextAlignment.Left} textSize={SdsTextSize.Medium} />
        </div>
      )}
      <ul className="sds-sidenav-list">{getMenuItems()}</ul>
    </section>
  );
};
